import clsx from "clsx";
import { ButtonHTMLAttributes, DetailedHTMLProps, PropsWithChildren } from "react";

type TitleProps = DetailedHTMLProps<ButtonHTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement> & { fontWeight?: FontWeight }
type FontWeight = "font-bold" | "font-medium" | "font-normal" | "font-light" | "font-extrabold" | "font-semibold"

export function Title({ children, className, fontWeight = "font-medium", ...headingProps }: PropsWithChildren<TitleProps>) {
    return <h1 className={clsx("text-2xl text-secondary-950", fontWeight, className)} {...headingProps}>{children}</h1>
}